import React from "react";

import { Icon } from "@chakra-ui/react";
import { MdPerson, MdPriceChange } from "react-icons/md";


import Users from "views/admin/Users";
import MainDashboard from "views/admin/default";
import { TfiDashboard } from "react-icons/tfi";
import AllOrganization from "views/admin/Organization/organization";
import { GoOrganization } from "react-icons/go";
import AllPricing from "views/admin/Pricing/pricing";

const routes = [
  {
    name: "Dashboard",
    module: "Main Dashboard",
    layout: "/",
    path: "/dashboard",
    icon: (
      <Icon
        as={TfiDashboard}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    access: ["SuperAdmin","Admin"],
    place: "top",
    component: <MainDashboard />,
  },
  {
    name: "Organization",
    module: "Organization",
    layout: "/",
    path: "/organization",
    icon: (
      <Icon
        as={GoOrganization}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    access: ["SuperAdmin","Admin"],
    place: "top",
    component: <AllOrganization />,
  },
  {
    name: "Pricing",
    module:'Pricing',
    layout: "/",
    path: "/pricing",
    icon: <Icon as={MdPriceChange} width="20px" height="20px" color="inherit" />,
    access: ["SuperAdmin","Admin"],
    place: "bottom",
    component: <AllPricing />,
  },
  {
    name: "Users",
    module:'Users',
    layout: "/",
    path: "/users",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    access: ["SuperAdmin","Admin"],
    place: "bottom",
    component: <Users />,
  },
 
];

export default routes;
